/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q_Siparis_OnaylamaInputs */

const tr_faq_q_siparis_onaylama = /** @type {(inputs: Faq_Q_Siparis_OnaylamaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gelen siparişleri nasıl onaylıyorum?`)
};

const en_faq_q_siparis_onaylama = /** @type {(inputs: Faq_Q_Siparis_OnaylamaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I approve incoming orders?`)
};

const de_faq_q_siparis_onaylama = /** @type {(inputs: Faq_Q_Siparis_OnaylamaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie genehmige ich eingehende Bestellungen?`)
};

const ru_faq_q_siparis_onaylama = /** @type {(inputs: Faq_Q_Siparis_OnaylamaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как одобрить входящие заказы?`)
};

/**
* | output |
* | --- |
* | "How do I approve incoming orders?" |
*
* @param {Faq_Q_Siparis_OnaylamaInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_q_siparis_onaylama = /** @type {((inputs?: Faq_Q_Siparis_OnaylamaInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q_Siparis_OnaylamaInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q_siparis_onaylama(inputs)
	if (locale === "de") return de_faq_q_siparis_onaylama(inputs)
	if (locale === "ru") return ru_faq_q_siparis_onaylama(inputs)
	return tr_faq_q_siparis_onaylama(inputs)
});